"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["AlignLeftSides"] = 0] = "AlignLeftSides";
    HorizontalAlignment[HorizontalAlignment["AlignRightSides"] = 1] = "AlignRightSides";
})(HorizontalAlignment = exports.HorizontalAlignment || (exports.HorizontalAlignment = {}));
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Above"] = 0] = "Above";
    VerticalAlignment[VerticalAlignment["Below"] = 1] = "Below";
})(VerticalAlignment = exports.VerticalAlignment || (exports.VerticalAlignment = {}));
/* Calculates an absolute position where the elementToPosition should be placed so that it
 * appears aligned, as specified, with the relativeElement.  If in the specified alignment
 * the elementToPosition would overflow outside of the browser window then uses the other
 * alignment (left vs. right, above vs. below).  If neither alignment can fit then uses
 * the originally specified alignment.
 */
function getRelativePosition(elementToPosition, relativeElement, horizontalAlignment, verticalAlignment, fixed) {
    var relativeRect = relativeElement.getBoundingClientRect();
    var elementRect = elementToPosition.getBoundingClientRect();
    var top = calculateTop(relativeRect, elementRect, verticalAlignment, fixed);
    var left = calculateLeft(relativeRect, elementRect, horizontalAlignment);
    return { top: top, left: left };
}
exports.getRelativePosition = getRelativePosition;
function calculateTop(relativeRect, elementRect, verticalAlignment, fixed) {
    var scrollFactor = fixed ? 0 : window.pageYOffset; // note: must use pageYOffset not scrollY for IE
    var hasRoomBelow = relativeRect.bottom + elementRect.height < window.innerHeight;
    var hasRoomAbove = relativeRect.top - elementRect.height >= 0;
    if (verticalAlignment == VerticalAlignment.Below && !hasRoomBelow && hasRoomAbove)
        verticalAlignment = VerticalAlignment.Above;
    else if (verticalAlignment == VerticalAlignment.Above && !hasRoomAbove && hasRoomBelow)
        verticalAlignment = VerticalAlignment.Below;
    if (verticalAlignment == VerticalAlignment.Below)
        return relativeRect.bottom + scrollFactor;
    else
        return relativeRect.top - elementRect.height + scrollFactor;
}
function calculateLeft(relativeRect, elementRect, horizontalAlignment) {
    var hasRoomToAlignLeft = relativeRect.left + elementRect.width < window.innerWidth;
    var hasRoomToAlignRight = relativeRect.right - elementRect.width > 0;
    if (horizontalAlignment == HorizontalAlignment.AlignLeftSides && !hasRoomToAlignLeft && hasRoomToAlignRight)
        horizontalAlignment = HorizontalAlignment.AlignRightSides;
    else if (horizontalAlignment == HorizontalAlignment.AlignRightSides && !hasRoomToAlignRight && hasRoomToAlignLeft)
        horizontalAlignment = HorizontalAlignment.AlignLeftSides;
    if (horizontalAlignment == HorizontalAlignment.AlignLeftSides)
        return relativeRect.left;
    else
        return relativeRect.right - elementRect.width;
}
function getAbsolutePostion(elementToPosition, x, y) {
    var elementRect = elementToPosition.getBoundingClientRect();
    var adjustedX = x;
    var adjustedY = y;
    if (x < 0)
        adjustedX = 0;
    else if (x + elementRect.width > window.innerWidth)
        adjustedX = x - ((x + elementRect.width) - window.innerWidth);
    if (y < 0)
        adjustedY = 0;
    else if (y + elementRect.height - window.pageYOffset > window.innerHeight) // note: must use pageYOffset not scrollY for IE
        adjustedY = y - ((y + elementRect.height - window.pageYOffset) - window.innerHeight);
    return { x: adjustedX, y: adjustedY };
}
exports.getAbsolutePostion = getAbsolutePostion;
